import certificado1 from "./../assets/certificado1.png";
import certificado2 from "./../assets/certificado2.png";
import certificado3 from "./../assets/certificado3.png";
import certificado4 from "./../assets/certificado4.png";
import certificado5 from "./../assets/certificado5.png";
import certificado6 from "./../assets/certificado6.png";
import certificado7 from "./../assets/certificado7.png";
import certificado8 from "./../assets/certificado8.png";
import certificado9 from "./../assets/certificado9.png";
import certificado10 from "./../assets/certificado10.png";
import certificado11 from "./../assets/certificado11.png";
import certificado12 from "./../assets/certificado12.png";

const certificados = [
  {
    name: "Condición del Espectro Autista y Apoyos Funcionales desde una mirada respetuosa",
    role: "22 Agosto 2020",
    imageUrl: certificado9,
    tag: "TEA",
    tagColor: "bg-primary-lighter text-primary",
  },
  {
    name: "Estrategias de evaluación para padres y cuidadores (as)",
    role: "6 de Junio 2020",
    imageUrl: certificado8,
    tag: "Evaluación",
    tagColor: "bg-warm-lighter text-warm",
  },
  {
    name: "Certificación de Aquafitness - Nivel Básico",
    role: "Octubre 2020",
    imageUrl: certificado11,
    tag: "Acuático",
    tagColor: "bg-ocean-lighter text-ocean",
  },
  {
    name: "Principales estrategias de identificación e intervención en niños y niñas con discapacidad visual",
    role: "Octubre 2020 a Noviembre 2020",
    imageUrl: certificado10,
    tag: "Inclusión",
    tagColor: "bg-mint-lighter text-mint",
  },
  {
    name: "Certificación Tutor Sombra",
    role: "Octubre 2020 a Diciembre 2020",
    imageUrl: certificado7,
    tag: "Tutor Sombra",
    tagColor: "bg-primary-lighter text-primary",
  },
  {
    name: "Certificación de Instructor de Aquafitness Método APT - Aqua Power Training",
    role: "Diciembre 2020 a Febrero 2021",
    imageUrl: certificado12,
    tag: "Acuático",
    tagColor: "bg-ocean-lighter text-ocean",
  },
  {
    name: "Taller de Padres Baby Signs",
    role: "Enero 2021",
    imageUrl: certificado2,
    tag: "Familia",
    tagColor: "bg-warm-lighter text-warm",
  },
  {
    name: "Diplomado en Inclusión Educativa",
    role: "Enero 2021 a Abril 2021",
    imageUrl: certificado6,
    tag: "Educación",
    tagColor: "bg-mint-lighter text-mint",
  },
  {
    name: "Evaluación del Procesamiento Sensorial: Perfil Sensorial 2 Winnie Dunn",
    role: "13 y 14 de abril 2021",
    imageUrl: certificado1,
    tag: "Sensorial",
    tagColor: "bg-primary-lighter text-primary",
  },
  {
    name: "Introducción a la Medicina del Estilo de Vida",
    role: "3 de Octubre 2021 hasta 20 de Noviembre 2021",
    imageUrl: certificado4,
    tag: "Salud",
    tagColor: "bg-mint-lighter text-mint",
  },
  {
    name: "Comunicación en Lengua de Señas Chilena, Nivel Básico A1",
    role: "Enero a Febrero 2022",
    imageUrl: certificado3,
    tag: "LSCh",
    tagColor: "bg-warm-lighter text-warm",
  },
  {
    name: "Comunicación para Todos",
    role: "Noviembre 2021 a Marzo 2022",
    imageUrl: certificado5,
    tag: "Comunicación",
    tagColor: "bg-primary-lighter text-primary",
  },
];

export default function Certificados() {
  return (
    <section className="bg-primary-lighter overflow-hidden" id="certificados">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-white text-primary font-body font-semibold text-sm px-4 py-1.5 rounded-full mb-3 shadow-soft">
            Formación Continua
          </span>
          <h2 className="font-heading text-4xl sm:text-5xl font-semibold text-gray-800">
            Certificados de Cursos
          </h2>
          <p className="mt-3 text-gray-500 font-body text-base max-w-lg mx-auto">
            Comprometida con el aprendizaje constante para brindar la mejor atención
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {certificados.map((certificado, index) => (
            <div
              key={certificado.name}
              className="group bg-white rounded-3xl overflow-hidden shadow-soft hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              {/* Image */}
              <div className="relative overflow-hidden aspect-w-4 aspect-h-3">
                <img
                  className="w-full h-40 object-cover transition-transform duration-500 group-hover:scale-105"
                  src={certificado.imageUrl}
                  alt={certificado.name}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>

              {/* Content */}
              <div className="p-4">
                <span className={`inline-block text-xs font-body font-semibold px-3 py-1 rounded-full mb-2 ${certificado.tagColor}`}>
                  {certificado.tag}
                </span>
                <h3 className="font-heading text-sm font-semibold text-gray-800 leading-snug mb-1 line-clamp-3">
                  {certificado.name}
                </h3>
                <p className="text-xs text-primary font-body font-medium">{certificado.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Wave */}
      <div className="w-full overflow-hidden leading-none">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" preserveAspectRatio="none">
          <path d="M0,30 C480,60 960,0 1440,30 L1440,60 L0,60 Z" fill="#ffffff" />
        </svg>
      </div>
    </section>
  );
}
